@if (item().route) {
  <a
    class="menu-link"
    [routerLink]="item().route"
    routerLinkActive="active"
    #linkActive="routerLinkActive"
    [routerLinkActiveOptions]="{ exact: item().exact ?? false }"
    [attr.aria-current]="linkActive.isActive ? 'page' : null"
    [attr.title]="rail() ? item().label : null"
    (click)="onNavigate()">
    @if (item().icon) {
      <span class="menu-icon" aria-hidden="true"><i class="bi bi-{{ item().icon }}"></i></span>
    }
    <span class="menu-title">{{ item().label }}</span>
    @if (rail()) {
      <span class="menu-tip" aria-hidden="true">{{ item().label }}</span>
    }
  </a>
} @else if (hasChildren()) {
  <button
    class="menu-link"
    type="button"
    [attr.aria-expanded]="expanded()"
    [attr.title]="rail() ? item().label : null"
    (click)="toggle()">
    @if (item().icon) {
      <span class="menu-icon" aria-hidden="true"><i class="bi bi-{{ item().icon }}"></i></span>
    }
    <span class="menu-title">{{ item().label }}</span>
    <i class="bi bi-chevron-down menu-caret" [class.is-open]="expanded()" aria-hidden="true"></i>
    @if (rail()) {
      <span class="menu-tip" aria-hidden="true">{{ item().label }}</span>
    }
  </button>

  @if (expanded() && !rail()) {
    <div class="menu-children">
      @for (child of children(); track child.label) {
        <a
          class="menu-link menu-link--child"
          [routerLink]="child.route"
          routerLinkActive="active"
          #childActive="routerLinkActive"
          [routerLinkActiveOptions]="{ exact: child.exact ?? false }"
          [attr.aria-current]="childActive.isActive ? 'page' : null"
          (click)="onNavigate()">
          @if (child.icon) {
            <span class="menu-icon" aria-hidden="true"><i class="bi bi-{{ child.icon }}"></i></span>
          }
          <span class="menu-title">{{ child.label }}</span>
        </a>
      }
    </div>
  }
}
